import { HistogramLogModel } from '@rift/models/restapi/HistogramLog.Model';
import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IHistogramLogPageModel extends IRestModel {
    deviceSerial: number;
    friendlyDeviceSerial: string;
    nextIndex: number;
    histogramLogs: Array<HistogramLogModel>;
}

export class HistogramLogPageModel extends BaseModel implements IHistogramLogPageModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;

    public deviceSerial: number = null;
    public friendlyDeviceSerial: string = null;
    public nextIndex: number = null;
    public histogramLogs: Array<HistogramLogModel> = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-HistogramLogPageModel');

        this.histogramLogs = RestModelUtility.loadFromArray(restModel.HistogramLogs, HistogramLogModel);
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
        };
    }
}
